import React, {useEffect, useState} from 'react';

// custom components
import {Footer, Text, PageNavigator } from '../../components/atoms';
import { ApiTitle, TabList, List, TableNumber, Callout, RequestHeader, RequestFields, HttpRequest} from '../../components/molecules';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

// image
import AuthenticationDiagram from '../../assets/images/authentication/authentication.png'

// swagger
import SwaggerUI from "swagger-ui-react";

// code
import sample from '../../utils/code/postBookingBody';
import { CopyBlock, dracula} from "react-code-blocks";

// utils
import { Colors } from '../../styles';

const codeStyle = {
    fontFamily: 'monospace',
    fontSize: 16,
    backgroundColor: '#f0f0f0',
    color: "#000000",
    padding: 4,
    borderRadius: 4,
};


const Authentication = (props) => {

    const [tab, setTab] = useState(0)

    useEffect(() => {

    }, []);

    const TitleText = (props) => { return ( <p style={{ fontWeight:'bold', fontSize:14 }}>{props.children}</p>)}
    const TextText = (props) => { return ( <p style={{ fontWeight:'300', fontSize:14 }}>{props.children}</p>)}

    const ResponseTable = (props) => {
        return (
            <div>
                <table class="table" style={{ }}>
                    <thead style={{}}>
                        <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                            <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Code</Text.TableHeader></th>
                            <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Description</Text.TableHeader></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>200 Ok</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Included in the response is the generated JWT, that is valid for 20 minutes after creation. To generate another token, simply re-execute this request.'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>400 Bad Request</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>Indicates that there was an error in the request. </Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>403 Unauthorized Access</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request is unauthorized. Typically the result of not including the Authorization header in the request.'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>500 Internal Server Error</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request did not go through due to an internal error.'}</Text.TableBody></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    const Body = (props) => {
        return (
        <div>
            <table class="table" style={{ }}>
                <thead style={{}}>
                    <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                        <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Parameter</th>
                        <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Description</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>client_id</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>{'user client ID'}</Text.TableBody></td>
                    </tr>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>client_secret</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>user client secret ID</Text.TableBody></td>
                    </tr>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>type</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>r/w</Text.TableBody></td>
                    </tr>
                </tbody>
            </table>
        </div>
        )
    }

    return (
        <>
            {/* Title and Prerequisities */}
            <Row className='mt-5'>
                <Col>
                    <ApiTitle 
                        smallTitle={'Authentication Request'}
                        title={'Authentication'}
                        subtitle={'Use this guide to learn how to get access to the PRM Connect API.'}
                        prerequisites={[
                            'Client ID',
                            'Client Secret Key',
                        ]}
                    />
                </Col>
            </Row>

            {/* Overview */}
            <Row>
                <Col>
                    <Text.Subheading>Overview</Text.Subheading>
                    <Text.Text>{`This section covers how to retrieve a JWT to access to the PRM Connect API. PRM Connect users are provided with a client ID and Client Secret that is to be stored in a secure manner. The PRM Connect API authenticates incoming requests using JSON Web Tokens (JWT). With every request made, the Authorization request header should be of the form Bearer <token>, with <token> being replaced with a user’s JWT. The following section describes how to obtain a JWT.`}</Text.Text>
                    <TableNumber title={'1.1 Requesting Authentication'} description={'The clients uses their Client ID and Client Password to generate a JWT, which is then used to authenticate all future requests'} />
                    <div className="row text-center">
                    <img
                        src={AuthenticationDiagram}
                        width={
                            '250px'
                        }
                        alt=""
                    />
                    </div>
                </Col>
            </Row>
            
            {/* Selector Tab List */}
            <Row>
                <Col>
                    <TabList 
                        tabs={['Overview', 'Example', 'Implementation']}
                        setTab={(value)=>{ setTab(value)}}
                    />
                </Col>
            </Row>

            { tab == 1 && 
            <>
            {/* 3. Request */}
            <Row className='mt-4'>
                <Col>
                    <Container>
                        <Text.Subheading>Request</Text.Subheading>
                        <Text.Text>{'This section describes the process of creating a JWT for a PRM Connect user with an outline of the endpoint, an example request and response, JSON schemas for request, responses and error response codes.'}</Text.Text>     
                    </Container>
                </Col>
            </Row>
            
            {/* 3.1 Headers */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>1.1 Request Body</Text.Subheading>
                        <Text.Text>The request body contains the user’s Client ID and Secret. Additionally, the request body must include the type of token being requested. Requesting an <span style={codeStyle}>r</span> type token (read-only) only allows GET requests. A <span style={codeStyle}>w</span> type token (read/write) allows for the modification and creation of bookings.</Text.Text>
                        <Body />
                    </Container>
                </Col>
            </Row>

            {/* 3.3 Response */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.3 Request Response</Text.Subheading>
                        <Text.Text>{'This section reviews the different responses and their meaning.'}</Text.Text>
                        <ResponseTable />
                    </Container>
                </Col>
            </Row>
            </>
            }

            { tab == 2 &&
            <>
            {/* Example Request w/ request body */}
            <Row className='mt-4'>
                <Col >
                    <Container>

                        {/* Text */}
                        <Text.Subheading>1. Example Request</Text.Subheading>
                        <Text.Text>{'This section contains examples of requesting a JSON Web Token (JWT) using a Client ID and client secret.'}</Text.Text>
                        
                        <Text.Subsubheading>1.1.1 Request</Text.Subsubheading>
                        <HttpRequest 
                            requestType={'POST'}
                            url={'https://connect.prmassist.com/api/v1/credentials'}
                            headers={['Authorization: Bearer <token>', 'Content-Type: [application/json]']}
                            body={'{client_id : <clientid>, client_secret : <clientsecret>, type : r/w}'}
                        />

                    </Container>
                </Col>
            </Row>
        
            {/* Example Response */}
            <Row className='mt-5'>
                <Col >
                    <Container>
                        
                        {/* Text */}
                        <Text.Subsubheading>1.1.2 Response</Text.Subsubheading>
                        <Text.Text>Included in the response is the generated JWT, that is valid for 20 minutes after creation. To generate another token, simply re-execute this request. </Text.Text>
                        
                        {/* Code block */}
                        <Row>
                            <Col>
                                <p>Response from Request</p>
                                <CopyBlock
                                    language={'json'}
                                    text={sample['jwt']}
                                    showLineNumbers={false}
                                    theme={dracula}
                                    wrapLines={false}
                                />
                            </Col>
                        </Row>

                    </Container>
                </Col>
            </Row>
            </>
            }

            { tab == 3 &&
            <>
            <Row className='mt-4'>
                <Col >
                   <Container>

                        <Text.Subheading>Swagger Implementation</Text.Subheading>
                        <Text.Text>{'This section contains a swagger that can be used for posting an example booking, reviewing the different responses and error codes'}</Text.Text>

                        <SwaggerUI url="get_credentials.yaml" />

                   </Container>
               </Col>
           </Row>
            </>
            }

            {/* Page Navigator */}
            <Row>
                <Col>
                    <Container>
                        <PageNavigator leftText={'Getting Started'} leftLink={'/getting-started'}  rightText={'Create a Booking'} rightLink={'/create-booking'} />
                    </Container>
                </Col>
            </Row>
            
            <Footer small={true} />
        </>
    );
};

export default Authentication;
